import { type AnyElement, type AnyElementData } from '../all-element-types';
import {
  type Element,
  type ElementData,
  elementType,
  type ElementType,
} from '../element';

import { type UnfurlData } from './unfurling';

export const smartLinkKinds = ['block', 'embed', 'inline'] as const;
export type SmartLinkKind = (typeof smartLinkKinds)[number];

export type LinkOrSmartLink = 'url' | SmartLinkKind;

export interface SmartLinkElementData extends ElementData<ElementType>, UnfurlData {
  url: string;
  supportedViews: SmartLinkKind[];
  kind: SmartLinkKind;
  supportsPreview: boolean;
  ari?: string;
  /**
   * ⚠️ If we ever add basisSize and basisPosition here, ensure that the corresponding type-guards
   * are updated accordingly in @link packages/sizing-feature-flags/src/sizing-feature-flags.ts
   */
}

export interface SmartLinkElement extends SmartLinkElementData, Element<ElementType> {}

export function isSmartLink(
  element: AnyElement | undefined
): element is SmartLinkElement {
  return !!element && element.type === smartLinkElementType;
}

export function isSmartLinkData(
  element: AnyElementData | Omit<AnyElementData, 'id'> | undefined
): element is SmartLinkElementData {
  return !!element && element.type === smartLinkElementType;
}

export interface Size {
  width: number;
  height: number;
}

export interface SmartLinkSizeInfo {
  inline: Size;
  embed: Size;
  data: Size;
  preview: Size;
}

export interface SmartLinkViewInfo {
  kind: SmartLinkKind;
  size: SmartLinkSizeInfo;
}

export const smartLinkElementType = elementType('smartLink');
